<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.5498 0.549805L11.2165 2.88318L8.5498 5.21656" stroke="#2D2D2D" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M0.549805 5.88336V4.21666C0.549805 3.86303 0.690283 3.52389 0.940336 3.27383C1.19039 3.02378 1.52953 2.8833 1.88316 2.8833H11.2167" stroke="#2D2D2D" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.54953 12.5501L1.88281 10.2167L4.54953 7.8833" stroke="#2D2D2D" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.5497 7.2168V8.8835C12.5497 9.23712 12.4092 9.57627 12.1592 9.82632C11.9091 10.0764 11.57 10.2169 11.2163 10.2169H1.88281" stroke="#2D2D2D" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
const cycleIcon = {
    name: 'cycleIcon',
    props: {
    }
}
export default cycleIcon
export { cycleIcon }
</script>